import { ReactElement } from 'react';
import { Routes } from 'src/shared/Routes';
import { RoutePropsOnlyComponent, TrackedRouteWithErrorBoundary } from 'src/tracking/tracked-route';
import { lazyRetry } from 'src/util/retry';

const TableRunCheckoutPage = lazyRetry(() => import('./TableRunCheckoutPage'));
const TableRunConfirmationPage = lazyRetry(() => import('./TableRunConfirmationPage'));
const TableRunDirectoryPage = lazyRetry(() => import('./directory'));
const TableRunSignupPage = lazyRetry(() => import('./TableRunSignupPage'));
const TableRunStorefrontPage = lazyRetry(() => import('./TableRunStorefrontPage'));

/**
 * The TableRun-branded pages, which are reachable on both tablerun.com and shef.com. Defined once
 * so a new one cannot be added to one host's `<Switch>` and forgotten in the other's.
 *
 * Returns an array rather than a fragment on purpose: `<Switch>` picks its match by reading
 * `path` off each child via `React.Children.forEach`, which descends into arrays but not into
 * fragments. Wrapped in a fragment these would become one child with no `path`, and every route
 * here would stop matching.
 */
export function tableRunBrandRoutes(): ReactElement<RoutePropsOnlyComponent>[] {
  return [
    <TrackedRouteWithErrorBoundary
      key={Routes.CONSUMER_TABLERUN_SIGNUP}
      path={Routes.CONSUMER_TABLERUN_SIGNUP}
      exact
      component={TableRunSignupPage}
    />,
    <TrackedRouteWithErrorBoundary
      key={Routes.CONSUMER_TABLERUN_CONFIRMATION}
      path={Routes.CONSUMER_TABLERUN_CONFIRMATION}
      exact
      component={TableRunConfirmationPage}
    />,
    <TrackedRouteWithErrorBoundary
      key={Routes.CONSUMER_TABLERUN_CHECKOUT}
      path={Routes.CONSUMER_TABLERUN_CHECKOUT}
      exact
      component={TableRunCheckoutPage}
    />,
    <TrackedRouteWithErrorBoundary
      key={Routes.CONSUMER_TABLERUN_STOREFRONT}
      path={Routes.CONSUMER_TABLERUN_STOREFRONT}
      exact
      component={TableRunStorefrontPage}
    />,
    <TrackedRouteWithErrorBoundary
      key={Routes.CONSUMER_TABLERUN_DIRECTORY}
      path={Routes.CONSUMER_TABLERUN_DIRECTORY}
      exact
      component={TableRunDirectoryPage}
    />,
  ];
}
